module.exports = __webpack_public_path__ + "static/bronze_dragon_wyrmling-459d49073bac6af57d0d70a3a221af9d.jpg";